module.exports = __webpack_public_path__ + "static/logo-bb1b7e4e0738ff1b6a985561d0d7561c.svg";